<template>
	<div :class="['overlay', {fluid: !$mq.desktop}]" @click="close">
		<div class="body">
			<button class="close" @click.prevent="close">
				<sprite name="close" />
			</button>
			<div class="upper">
				<nav>
					<div class="nav-group">
						<h5>Products</h5>
						<ul>
							<li><router-link :to="{name: 'productsEla'}">StudySyncELA</router-link></li>
							<li><router-link :to="{name: 'productsSyncblasts'}">SyncBlasts</router-link></li>
							<li><router-link :to="{name: 'productsGlobal'}">StudySyncGlobal</router-link></li>
						</ul>
					</div>
					<div class="nav-group">
						<h5>Company</h5>
						<ul>
							<li><router-link :to="{name: 'ourCompany'}">Company</router-link></li>
							<li><router-link :to="{name: 'contact'}">Contact</router-link></li>
						</ul>
					</div>
					<div class="nav-group">
						<h5>Remote Learning</h5>
						<ul>
							<li><router-link :to="{name: 'theDailySync'}">The Daily Sync</router-link></li>
							<li><router-link to="/remote-resources">Remote Resources</router-link></li>					
						</ul>
					</div>
					<div class="nav-group">
						<h5>Engage</h5>
						<ul>
							<li><router-link :to="{name: 'blog'}">Blog</router-link></li>
							<li><router-link :to="{name: 'webinars'}">Webinars</router-link></li>
							<li><router-link :to="{name: 'news'}">News</router-link></li>
							<li><router-link :to="{name: 'subscribe'}">Subscribe</router-link></li>
						</ul>
					</div>
				</nav>
				<div class="cta">
					<btn class="white"><router-link :to="{name: 'freeTrial'}">Try StudySync for Free</router-link></btn>
				</div>
				<ul class="social">
					<li>
						<a href="https://www.facebook.com/StudySync/" target="_blank"><sprite name="facebook" /></a>
					</li>
					<li>
						<a href="https://www.linkedin.com/company/bookheaded-learning-llc/" target="_blank"><sprite name="linkedin" /></a>
					</li>
					<li>
						<a href="https://www.youtube.com/user/studysync" target="_blank"><sprite name="youtube" /></a>
					</li>
					<li>
						<a href="https://twitter.com/studysync" target="_blank"><sprite name="twitter" /></a>
					</li>
					<li>
						<a href="https://www.instagram.com/studysync/" target="_blank"><sprite name="instagram" /></a>
					</li>
				</ul>
				<footer>
					<div class="copyright">
						© {{ currentYear }} BookheadEd Learning, LLC.
					</div>
					<ul>
						<li><router-link :to="{name: 'legalPrivacy'}">Privacy Policy</router-link></li>
						<li><router-link :to="{name: 'legalTerms'}">Terms of Use</router-link></li>
					</ul>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'overlayNav',
		data () {
			return {
				currentYear: (new Date()).getFullYear()
			}
		},
		methods: {
			close () {
				this.$store.commit('app/toggleOverlayNav', false)
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "responsive-font";
	@import "list-style-reset";
	@import "button-reset";
	@import "media";

	.overlay {
		height:100vh; position:fixed; right:0; transition:background 0.3s ease-in-out; z-index:999; width:100%;
		&.v-enter,
		&.v-leave-to {
			background-color:rgba(205, 205, 216, 0);
			.body {
				transform: translateX(100%);
			}
		}
	}

	.body {
		@include responsive-font(10);
		display:flex; flex-direction:column; align-items:center; width:40rem; height:100vh; padding:5vh; padding-bottom:75px; background:rgba(#3d3d3d, .95); margin-left:auto; transition:transform 0.3s ease-in-out; box-shadow:0 0 2em 0 rgba(#000, .25);
		overflow-y: scroll; -webkit-overflow-scrolling: touch;
		.overlay.fluid & {
			width:100%;
		}
	}

	.upper {
		width:100%;
		@include media(large) {
			flex:2 0;
		}
	}

	.close {
		@include button-reset;
		position:absolute; top:3rem; right:3rem; outline:none;
		svg {
			fill:#fff; width:3rem; height:auto;
		}
		.overlay.fluid & {
			top:4vh; right:4vh;
			svg {
				width:4vh;
			}
		}
	}

	.nav-group {
		font-family:'oswald'; line-height:1; text-transform:uppercase; letter-spacing:.15em;
		h5 {
			font-weight:400; color:#FDB913; font-size:1.5rem;
			.overlay.fluid & {
				font-size:1.5vh;
			}
		}
		ul {
			@include list-style-reset;
			display:flex; flex-direction:column; margin-top:1.25rem;
			.overlay.fluid & {
				margin-top:1.5vh;
			}
		}
		li + li {
			margin-top:1.25rem;
			.overlay.fluid & {
				margin-top:1.5vh;
			}
		}
		a {
			display:inline-block; text-decoration:none; font-weight:400; line-height:1; color:#fff; padding:.25vw; padding-left:0; font-size:2.1rem;
			.overlay.fluid & {
				font-size:3vh;
			}
		}
		& + .nav-group {
			margin-top:4rem;
		}
		.overlay.fluid & {
			font-size:4vh;
		}
	}

	.cta {
		margin-top:5rem;
		.overlay.fluid & {
			font-size:5vh;
		}
		a {
			font-size:1.8rem;
			.overlay.fluid & {
				font-size:2.25vh;
			}
		}
	}

	.social {
		@include list-style-reset;
		display:flex; justify-content:center; align-items:center; margin:3.5rem 0 2.5rem;
		.overlay.fluid & {
			margin:3.5vh 0 2.5vh;
		}
		li + li {
			margin-left:4rem;
			.overlay.fluid & {
				margin-left:4vh;
			}
		}
		svg {
			width:auto; height:2rem; fill:rgba(#fff, .5);
			.overlay.fluid & {
				height:3.25vh;
			}
		}
		a {
			display:block;
		}
		a:hover svg {
			fill:#fff;
		}
	}

	footer {
		text-align:center; color:rgba(#fff, .5); font-size:1.5rem; line-height:1.666;
		.overlay.fluid & {
			font-size:2vh;
		}
		ul {
			@include list-style-reset;
			display:flex; justify-content:center;
		}
		li + li:before {
			content:"|"; margin:0 .75em;
		}
		a {
			color:inherit; text-decoration:none;
			&:hover {
				color:#fff;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/OverlayNav/index.vue